export const App_Config = {
  shopId: 7,
  apiServerBaseUrl: 'https://mini.specialhome.com.cn/api/website/',
}